/**
 * Voice recording and waveform visualization constants.
 *
 * These values are used across the voice module to enforce recording limits,
 * control waveform sampling rates, and define preferred audio formats.
 */

const SEC = 1000;
const MIN = 60 * SEC;

/** Maximum recording length in milliseconds (10 min) */
export const MAX_VOICE_RECORDING_DURATION = 10 * MIN;

/** Number of downsampled bars shown in the waveform UI */
export const MAX_WAVEFORM_BARS = 50;

/** Default height for empty waveform bars (0–1) */
export const DEFAULT_BAR_HEIGHT = 0.15;

/** How often (ms) a new waveform peak is sampled during recording */
export const WAVEFORM_THROTTLE_MS = 50;

// ── Gesture thresholds ──

/** Horizontal drag distance (px) to trigger slide-to-cancel */
export const SLIDE_CANCEL_THRESHOLD = 150;

/** Vertical drag distance (px) to trigger recording lock */
export const LOCK_THRESHOLD = 80;

/** Long-press duration (ms) before recording starts */
export const LONG_PRESS_THRESHOLD = 500;

/** Preferred audio MIME types in priority order */
export const PREFERRED_AUDIO_TYPES = [
  "audio/webm;codecs=opus", // Chrome, Firefox, Safari 18.4+
  "audio/webm", // Wider WebM fallback
  "audio/mp4;codecs=aac", // Safari < 18.4, iOS
  "audio/mp4", // Safari fallback
  "audio/ogg;codecs=opus", // Firefox fallback
  "audio/ogg", // Wider OGG fallback
] as const;
